import { getJackpotIncrement } from '../utils/jackpotsV2/getJackpotIncrement';
import config from '../config';

const JACKPOT_TICKER_INTERVAL = 250;
const JACKPOT_UPDATE_INTERVAL = config.intervals.jackpotsCheck;

const useJackpotTileIncrement = getJackpotIncrement(
  'JACKPOT_TILE_INTERVAL',
  JACKPOT_TICKER_INTERVAL,
  JACKPOT_UPDATE_INTERVAL,
  ({ jackpotValue, previousJackpotValue }) => {
    const initialValue = jackpotValue - (JACKPOT_UPDATE_INTERVAL / 30000) * 0.6;
    if (jackpotValue < previousJackpotValue || !previousJackpotValue) {
      return initialValue < 0 ? 0 : initialValue;
    }
    return previousJackpotValue;
  }
);

export default useJackpotTileIncrement;
